import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

import Login from "./pages/Login";
import Register from "./pages/Register";
import OverviewPage from "./pages/OverviewPage";
import MePage from "./pages/MePage";
import Logout from "./pages/Logout";
import Today from "./pages/TodayPage";
import FoodPage from "./pages/FoodPage";
import MealPage from "./pages/MealPage";
// import FoodOverviewGrid from "./components/FoodOverviewGrid";
// import MealOverviewGrid from "./components/MealOverviewGrid";
// import TodayOverviewGrid from "./components/TodayOverviewGrid";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./routes/ProtectedRoute";

import { useDispatch } from "react-redux";
import { store } from "./store";

import { useEffect } from "react";
import { initialFoods, initialMeals } from "./store/seedData";
import { setFoods } from "./store/foodsSlice";
import { setMeals } from "./store/mealsSlice";
import { syncNow } from "./sync/syncService";


import theme from "./theme";


function App() {
  const isAuth = Boolean(localStorage.getItem("token"));
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(setFoods(initialFoods));
  //   dispatch(setMeals(initialMeals));
  // }, [dispatch]);



// useEffect(() => {
//   console.log("🚀 sync system started");

//   const interval = setInterval(() => {
//     console.log("⏱ interval tick");
//     syncNow(store);
//   }, 5000); // test with 5s

//   return () => clearInterval(interval);
// }, []);

// App.js

useEffect(() => {
  const state = store.getState();
  
  // Only seed if store is genuinely empty (no rehydrated or login data)
  if (!state.foods.allIds.length) dispatch(setFoods(initialFoods));
  if (!state.meals.allIds.length) dispatch(setMeals(initialMeals));
}, [dispatch]);

useEffect(() => {
  console.log("🚀 sync system started");

  const interval = setInterval(() => {
    syncNow(store);
  }, 5000);

  return () => clearInterval(interval);
}, []);

  return (
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <BrowserRouter>
          <Navbar />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              {/* <Route path="/dashboard" element={<TodayOverviewGrid />} /> */}
              <Route path="/overview" element={<OverviewPage />} />
              <Route path="/dashboard" element={<Today />} />
              <Route path="/me" element={<MePage />} />
              <Route path="/foods" element={<FoodPage />} />
              <Route path="/meals" element={<MealPage />} />
              <Route path="/logout" element={<Logout />} />
            </Route>

            {/* Root */}
            <Route
              path="/"
              element={
                <Navigate
                  to={isAuth ? "/dashboard" : "/login"}
                  replace
                />
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
  );
}

export default App;
